var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-error"},[_c('font-awesome-icon',{staticClass:"error-icon",attrs:{"icon":"exclamation-circle"}}),_c('div',{staticClass:"error-text"},[_vm._v("Failed to load chart data")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }